import React, { useState, useCallback } from "react";
import { omLogo } from "../../assets/images";
import { Typography, InputAdornment } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch } from "react-redux";
import { setAlertDialog } from "../../js/reducers/alertDialog";
import { useHistory } from "react-router-dom";
import { OAuth as OAuthActions } from "../../js/actions";
import PersonOutlineOutlinedIcon from "@material-ui/icons/PersonOutlineOutlined";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

const useStyles = makeStyles((theme) => ({
  parentDiv: {
    width: "100vw",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "1.5rem",
    boxSizing: "border-box",
  },
  loginCard: {
    position: "relative",
    width: "100%",
    maxWidth: "420px",
    padding: "2rem",
    borderRadius: "24px",
    background: "rgba(255, 255, 255, 0.72)",
    backdropFilter: "blur(22px)",
    WebkitBackdropFilter: "blur(22px)",
    border: "1px solid rgba(255, 255, 255, 0.6)",
    boxShadow:
      "0 20px 60px rgba(3, 46, 79, 0.28), inset 0 1px 0 rgba(255,255,255,0.6)",
    animation: "$cardFadeIn 0.6s ease",
    [theme.breakpoints.down("xs")]: {
      padding: "2rem 1.5rem",
      borderRadius: "20px",
    },
  },
  "@keyframes cardFadeIn": {
    from: { opacity: 0, transform: "translateY(24px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
  logoWrap: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "2rem",
  },
  logo: {
    height: "64px",
    width: "auto",
    objectFit: "contain",
  },
  title: {
    color: "#005691",
    fontWeight: 700,
    marginBottom: "0.5rem",
  },
  subtitle: {
    color: "#5a6b78",
    marginBottom: "1.5rem",
    fontSize: "0.9rem !important",
  },
  field: {
    marginBottom: "1.25rem",
    "& .MuiInputBase-root": {
      margin: "0 !important",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "14px !important",
      background: "rgba(255,255,255,0.65)",
      transition: "box-shadow 0.25s ease, background 0.25s ease",
      "& fieldset": {
        borderColor: "rgba(11, 60, 93, 0.15)",
      },
      "&:hover fieldset": {
        borderColor: "rgba(3, 169, 243, 0.5)",
      },
      "&.Mui-focused": {
        background: "rgba(255,255,255,0.95)",
        boxShadow: "0 6px 18px rgba(3, 169, 243, 0.18)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#03A9F3",
        borderWidth: "1.5px",
      },
    },
    "& .MuiOutlinedInput-input": {
      padding: "16.5px 2px",
      fontSize: "0.90em !important",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "#0288d1",
    },
  },
  inputIcon: {
    color: "#7a8b96",
  },
  submitButton: {
    padding: "0.6rem",
    borderRadius: "14px",
    fontWeight: 700,
    fontSize: "0.95rem !important",
    letterSpacing: "0.03em",
    textTransform: "none",
    color: "#fff",
    background: "linear-gradient(135deg, #0288d1 0%, #0B4759 100%)",
    display: "flex",
    justifyContent: "center",
    margin: "0.5rem auto",
    width: "30%",
    "&:hover": {
      background: "linear-gradient(135deg, #03A9F3 0%, #0B4759 100%)",
    },
  },
  backLink: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    color: "#0288d1",
    fontSize: "0.85rem !important",
    fontWeight: 600,
    marginTop: "1.4rem",
    transition: "color 0.2s ease",
    "&:hover": {
      color: "#0B4759",
      textDecoration: "underline",
    },
  },
  backIcon: {
    fontSize: "1.1rem !important",
    marginRight: "0.3rem",
  },
}));

const CardForgotPassword = ({ onCancel }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const [email, setEmail] = useState("");
  const [emailHelper, setEmailHelper] = useState("");

  const onChange = useCallback((event) => {
    let valid;
    if (event.target.id === "email") {
      setEmail(event.target.value);
      valid = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
        event.target.value
      );
      if (!valid && event.target.value.length !== 0) {
        setEmailHelper("Invalid email address");
      } else {
        setEmailHelper("");
      }
    }
  }, []);

  const submit = () => {
    if (email.length === 0) {
      setEmailHelper("Please enter email");
      return;
    }
    const isValidEmail = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email);
    if (!isValidEmail) {
      setEmailHelper("Invalid email address");
      return;
    }
    dispatch(OAuthActions.forgotPassword(email)).then(function (success) {
      if (success["error"] === undefined) {
        history.push({
          pathname: "/passkey",
          state: { registrationId: success.verificationToken },
        });
      } else {
        dispatch(
          setAlertDialog(
            true,
            null,
            "error",
            "Forgot Password",
            "Password reset unsuccessful. Please check your email Id.\nDetails Of Failure: " +
            success.message,
            "OK",
            ""
          )
        );
      }
    });
  };

  return (
    <div className={classes.parentDiv}>
      <div className={classes.loginCard}>
        <div className={classes.logoWrap}>
          <img src={omLogo} alt="login_logo" className={classes.logo} />
        </div>

        <Typography variant="h4" align="center" className={classes.title}>
          Forgot Password / New Registration
        </Typography>
        <Typography variant="body1" align="center" className={classes.subtitle}>
          Please enter your Email ID
        </Typography>

        <TextField
          fullWidth
          required
          variant="outlined"
          className={classes.field}
          error={emailHelper.length !== 0}
          helperText={emailHelper}
          id="email"
          placeholder="Email ID"
          value={email}
          onChange={(event) => onChange(event)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PersonOutlineOutlinedIcon className={classes.inputIcon} />
              </InputAdornment>
            ),
          }}
        />

        <Button
          size="large"
          variant="contained"
          className={classes.submitButton}
          onClick={submit}
        >
          Submit
        </Button>

        <Typography className={classes.backLink} onClick={onCancel}>
          <ArrowBackIcon className={classes.backIcon} />
          Back to Login
        </Typography>
      </div>
    </div>
  );
};

export default React.memo(CardForgotPassword);
